import logo from './assets/logo.png';

export const FONT = 'Raleway';
export const LOGO = logo;
